export const EmailButtonStyles = {
    marginTop: (theme) => theme.spacing(3)
}
